export interface Config {
    [key: string]: any;
    default_language: "sv-SE" | "en-US";
}
let default_config: Config = {
    default_language: "sv-SE",
    api: {
        api_url: 'https://tmpl-demo.data.thethingsnetwork.org/api/v2/query',
        api_authentication: 'key ttn-account-v2.GrNGsOpElRScQ991t1FlluzKdWd8eHGrMaxD6rqx648'
    }
};

export default default_config;


// WEBPACK FOOTER //
// ./src/default_config.ts